<template>
  <div class="view" v-if="isshowDialog">
    <div class="title shenhe-title" >
      <!-- <i class="goback el-icon-arrow-left" @click="goback"></i> -->
      {{titleInfo}}
      <div class="close" @click="closesp">
          <i class="el-icon-close"></i>
        </div>
    </div> 
    <div class="content whitebg" style="padding-top:40px; padding-bottom: 40px;">  
      <el-form :label-position="position" label-width="200px" :model="formdata">
         <el-form-item label="操作类型" prop="status" >
          <el-radio-group v-model="formdata.status" @change="changeshenheRadios">
            <template v-if="status == 0">
                <el-radio  :label="1">通过</el-radio>
                <el-radio  :label="2">拒绝</el-radio>
            </template>
            <template v-else>
              <el-radio   :label="3">禁用</el-radio>
              <el-radio :label="4">恢复</el-radio>
             </template>
          </el-radio-group>
        </el-form-item>
         <el-form-item label="分销员类型" prop="user_type" v-if="formdata.status == 1&& status ==0">
          <el-radio-group v-model="formdata.user_type" @change="changeRadios">
            <el-radio :label="1">外部分销员</el-radio>
            <el-radio :label="2">内部分销员</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item label="绑定活动员工" prop="activity"  v-if="formdata.status == 1 && formdata.user_type == 2 && status ==0">
          <el-button  @click="dialogActivity = true">选择绑定活动的员工</el-button>
          <div>
            <el-tag type="info" v-for="item in activity" :key="item.id">{{item.title}}</el-tag>
          </div> 
        </el-form-item>
       
        <el-form-item label="拒绝原因" prop="reasons" v-if="formdata.status == 2 && status ==0">
          <el-input type="textarea" class="w300" :rows="4" v-model="formdata.reasons" placeholder="请输入拒绝原因(最多30字)" maxlength="30" show-word-limit></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" plain size="small" @click="closesp"> 返回 </el-button>
          <el-button type="primary" size="small" @click="submit">提交</el-button>
        </el-form-item>
      </el-form>
    </div>
    <shenheDialog :visible.sync="dialogActivity" @updatePageInfo="updatePageInfo"></shenheDialog>

  </div>
</template>

<script>
import shenheDialog from '@/components/tkdialog/shenheDialog';
import api from "@/api.js";
export default {
  name: 'shenhe',
  components: {
    shenheDialog
  },
   props: {
    isshowDialog:Boolean,
    shenheinfo: Object
  },
  data() {
    return {
      titleInfo: '审核',
      // isShowStaffList:false,//是否显示员工列表  审核结果为内部时候显示
      // isShowReason:false,//是否显示拒绝原因  审核结果为内部时候显示
      position: 'right',
      dialogQrcode: false,
      dialogActivity: false,
      status:1,//1-正常，2-待审核，3-拒绝，4-禁用
      formdata: {
        id:'',//分销人员id
        status: 1,//操作类型，1-通过，2-拒绝，3-禁用，4-恢复,5-删除
        user_type:1,//分销员类型，通过时必传，1-外部分销员，2-内部分销员
        eid: '',//员工加密id,通过并且内部分销员时必传，取自Tuoke/employeeList接口
        reasons: ''//拒绝原因，拒绝时必传，最长30个字
      },
      options: [],
      activity : [],//员工列表
      
      qrcode: {},
      props: {
        multiple: true,
        value: 'id',
        label: 'name'
      }
    }
  },
  mounted() {
    // this.status = this.$route.params.status
    // this.formdata.id=this.$route.params.id
    // this.formdata.status=this.$route.params.status

     this.status = this.shenheinfo.status
     this.formdata.id=this.shenheinfo.id
     this.formdata.status=this.shenheinfo.status
    // console.log('mounted获取状态', this.formdata.status)
    this.axios
      .post(api.otherDifferentIndustry , {})
      .then(response => {
        if (response.data.code == 0) {
          this.options = response.data.result.list;
        } 
      }).catch(() => {})
  },
  methods: {
    closesp() {
      this.$emit("update:isshowDialog", false);
    },
    goback() {
      this.$router.go(-1);
    },
    updatePageInfo(option) {
      this.activity = option;
      let arr = [];
      for (let i = 0; i < option.length; i++) {
        arr.push(option[i].id);
      }
      // this.formdata.eid = arr.join(',');
      this.formdata.eid = arr[0];
    },
    onChange(e) {
      this.formdata.eid = e;
    },
    // 生成二维码id
    submit() {
      // console.log('提交表单',this.$route.params.id)
     
      let data = this.formdata
 
      if(this.formdata.status == 1 && !this.formdata.user_type){
        this.$message.error('请选择分销员类型');
        return
      }
      if(this.formdata.status == 1 && this.formdata.user_type == 2 && !this.formdata.eid){
        this.$message.error('请选择绑定的员工');
        return
      }
      if(this.formdata.status == 2 && !this.formdata.reasons){
          this.$message.error('请填写拒绝原因');
          return
      }
      this.axios
        .post(api.changeRecommend, data)
        .then(response => {
          if( response.data.code == 0){
            this.$message.success(response.data.msg);
            // this.$router.go(-1);
            this.$emit("update:isshowDialog", false);
            this.$emit("updateData", 1);  
          }
        }).catch(() => {})
    },
    changeRadios(value){

      // this.isShowStaffList =false
      // if(value == 2){
      //     this.isShowStaffList = true
      // }
      //分销员类型
      this.formdata.user_type = value
    },
    changeshenheRadios(value){
      //审核状态
      this.formdata.status = value
      // if(this.formdata.status == 2){
      //   this.isShowReason =true
      // }
    }
  }
}
</script>